export default __webpack_public_path__ + "static/media/106_mikroo.6642de69.png";